export default __webpack_public_path__ + "static/media/VINCI_FC_background_logo.a5442aa2.svg";